import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public id = 0;

  public showSubject = new Subject<any>();

  constructor(
  ) { }

  generateConfig(type, message, options: any = { classname: '', delay: 1000 }) {
    const timestamp = new Date().getTime();
    return {
        type,
        id: this.id++,
        classname: options.classname,
        delay: options.delay,
        message,
        timestamp
    };
  }

  show(type, message, options: any = { classname: '', delay: 1000 }) {
    const config = this.generateConfig(type, message, options);
    return this.showSubject.next(config)
  }

  showSuccess(message, options: any = { classname: '', delay: 1000 }) {
    return this.show('success', message, options);
  }

  showWarning(message, options: any = { classname: '', delay: 1000 }) {
    return this.show('warning', message, options);
  }

  showDanger(message, options: any = { classname: '', delay: 1000 }) {
    return this.show('danger', message, options);
  }
}
